import Image from 'next/image'
import { HowItWorksRoot, IsotypeContainer, Steps, Wrapup } from './HowItWorks.styles'

import isotype from '../../../../../../../public/assets/isotype-fill.svg'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import Trans from 'next-translate/Trans'
import { Step } from './components/Step'

export const HowItWorks = () => {
  const { t } = useTranslation()

  return (
    <HowItWorksRoot id="raw-food-subscription-1">
      <IsotypeContainer>
        <Image src={isotype} alt="" />
      </IsotypeContainer>

      <Stack direction="column" gap="3">
        <Text as="h2" size="h1" weight="bold" align="center">
          {t('raw-food-subscription:how-it-works.title')}
        </Text>

        <Stack direction="column" gap="5">
          <Text as="p" size="headline" align="center">
            <Trans
              i18nKey="raw-food-subscription:how-it-works.subtitle"
              components={{ bold: <strong /> }}
            />
          </Text>

          <Steps>
            <Step
              number="1"
              title={t('raw-food-subscription:how-it-works.step1.title')}
              description={t('raw-food-subscription:how-it-works.step1.description')}
            />
            <Step
              number="2"
              title={t('raw-food-subscription:how-it-works.step2.title')}
              description={t('raw-food-subscription:how-it-works.step2.description')}
            />
            <Step
              number="3"
              title={t('raw-food-subscription:how-it-works.step3.title')}
              description={t('raw-food-subscription:how-it-works.step3.description')}
            />
          </Steps>
        </Stack>

        <div>
          <Wrapup>
            <Text as="p" size="headline" weight="bold" align="center">
              {t('raw-food-subscription:how-it-works.wrap-up')}
            </Text>
          </Wrapup>
        </div>
      </Stack>
    </HowItWorksRoot>
  )
}
